<template>
    <el-sub-menu :index="menuItem.UniqueId" v-if="isSubItem">
        <template #title>
            <i class="el-icon"><i :class="menuItem.IconClass" /></i>
            <span>{{ menuItem.LinkText }}</span>
        </template>
        <menuItem v-for="(item,index) in menuItem.Items"
            :menuItem = "item"
            :key = "item.UniqueId"></menuItem>
    </el-sub-menu>
    <el-menu-item v-else :index="routePath">
        <template #title>
            <span>{{ menuItem.LinkText }}</span>
        </template>  
        <i class="el-icon"><i :class="menuItem.IconClass" /></i>
    </el-menu-item>
</template>

<script>
    import { RoutePathBuilder } from "."
    import { Location } from '@element-plus/icons-vue'

    let menuItem = {
        name:"menuItem",
        props: {
            menuItem: Object
        },
        
        components:{
            'location':Location
        },

        computed: {
            isSubItem: function () {
                return this.menuItem.Items.length > 0
            },
            routePath: function () {
                return RoutePathBuilder(this.menuItem) ;
            }
        }
    }

    export default menuItem
</script>